<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      toggled: false,
      selectedName: '',
      selectedProduct: null,
      selectedBrands: [],
      validation: {
        selectedName: [
          v => !!v || this.$t('createFilter.validation.name.required'),
          v => v.length <= 100 || this.$t('createFilter.validation.name.length'),
        ],
        selectedProduct: [
          v => !!v || this.$t('createFilter.validation.product.required'),
        ],
        selectedBrands: [
          v => !!v || this.$t('createFilter.validation.brands.required'),
        ],
      },
    };
  },
  computed: {
    ...mapState({
      createLoading: state => state.filter.list.createLoading,
      products: state => state.app.auth.products,
      brands: state => state.app.auth.brands,
    }),
  },
  methods: {
    ...mapActions({
      createFilter: 'filter/createFilter',
    }),
    create() {
      if (!this.createLoading && this.$refs.form.validate()) {
        this.createFilter({
          name: this.selectedName,
          product: this.selectedProduct,
          brands: this.selectedBrands,
        });
      }
    },
    reset() {
      if (!this.createLoading) {
        this.selectedName = '';
        this.selectedProduct = this.products[0].id;
        this.selectedBrands = [];
        this.$refs.form.resetValidation();
      }
    },
    close() {
      if (!this.createLoading) {
        this.toggled = false;
      }
    },
  },
  watch: {
    toggled(newVal) {
      if (newVal) {
        this.reset();
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    :persistent="createLoading"
    max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary">
        {{ $t('createFilter.modalButton') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="title">
          {{ $t('createFilter.title') }}
        </span>
      </v-card-title>
      <v-divider/>
      <v-card-text class="pa-0">
        <v-form ref="form">
          <div class="pa-4">
            <div class="title mb-3">
              {{ $t('createFilter.labels.name') }}
            </div>
            <div class="body-1 mb-3">
              {{ $t('createFilter.descriptions.name') }}
            </div>
            <v-text-field
              v-model="selectedName"
              :rules="validation.selectedName"
              :disabled="createLoading"
              :counter="50"
              required/>
          </div>
          <v-divider/>
          <div class="pa-4">
            <div class="title mb-3">
              {{ $t('createFilter.labels.brands') }}
            </div>
            <div class="body-1 mb-3">
              {{ $t('createFilter.descriptions.brands') }}
            </div>
            <v-select
              :value="selectedBrands[0]"
              :items="brands"
              :rules="validation.selectedBrands"
              :disabled="createLoading"
              item-value="id"
              item-text="name"
              @change="selectedBrands = [$event]"/>
          </div>
          <v-divider/>
          <div class="pa-4">
            <div class="title mb-3">
              {{ $t('createFilter.labels.product') }}
            </div>
            <div class="body-1 mb-3">
              {{ $t('createFilter.descriptions.product') }}
            </div>
            <v-select
              v-model="selectedProduct"
              :items="products"
              :rules="validation.selectedProduct"
              :disabled="createLoading"
              item-value="id"
              item-text="name"/>
          </div>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pa-4">
        <v-spacer/>
        <v-btn
          flat
          @click="close">
          {{ $t('buttons.close') }}
        </v-btn>
        <v-btn
          dark
          flat
          color="red"
          @click="reset">
          {{ $t('buttons.reset') }}
        </v-btn>
        <v-btn
          dark
          color="blue"
          :loading="createLoading"
          @click="create">
          {{ $t('buttons.add') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/TwCreateFilter.vue